export default "__VITE_ASSET__DKMbEE8n__"